import { API } from './index';

export function getInitialConfig(): Promise<any> {
    return API.get('control/get-initial-config');
}

export function getPricesControl(project: string): Promise<any> {
    return API.get(`control/get-prices?project=${project}`);
}